import { apiSlice } from '../app/api/apiSlice';

export const reviewsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getReviews: builder.query({
      query: ({ page = 1, limit = 10, search = '', status = '', rating = '' } = {}) => {
        const params = new URLSearchParams();
        if (page) params.append('page', page);
        if (limit) params.append('limit', limit);
        if (search) params.append('search', search);
        if (status) params.append('status', status);
        if (rating) params.append('rating', rating);

        return {
          url: `reviews${params.toString() ? `?${params.toString()}` : ''}`,
        };
      },
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
    }),
    updateReviewStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `reviews/${id}/status`,
        method: 'PUT',
        body: { status },
      }),
    }),
    deleteReview: builder.mutation({
      query: (id) => ({
        url: `reviews/${id}`,
        method: 'DELETE',
      }),
    }),
    exportReviews: builder.query({
      query: ({ search = '', status = '', rating = '' } = {}) => {
        const params = new URLSearchParams();
        if (search) params.append('search', search);
        if (status) params.append('status', status);
        if (rating) params.append('rating', rating);

        return {
          url: `admin/reviews/export${params.toString() ? `?${params.toString()}` : ''}`,
          responseHandler: (response) => response.blob(),
        };
      },
    }),
  }),
});

export const {
  useGetReviewsQuery,
  useLazyGetReviewsQuery,
  useUpdateReviewStatusMutation,
  useDeleteReviewMutation,
  useLazyExportReviewsQuery,
} = reviewsApiSlice;
